/* eslint-disable react/no-unstable-nested-components */
import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import AtomCard from '@s-ui/react-atom-card'
import Context from '@s-ui/react-context'
import CardAlert from '@adv-mt/mt-card-alert'
import EmptyCaseAlerts from '@adv-mt/mt-empty-case-alerts'
import NotificationAlert, {NOTIFICATIONS} from '@adv-mt/mt-notifications-alert'

import {BASE_CLASS} from '../config.js'

const WrapperAlerts = ({currentAlerts, listFiltersOptions, onUpdateAlert, pageName}) => {
  const {isMotos} = useContext(Context)

  const [notificationType, setNotificationType] = useState(NOTIFICATIONS.EMPTY)
  const [show, setShow] = useState(false)

  const closeNotification = () => {
    setShow(false)
    setNotificationType(NOTIFICATIONS.EMPTY)
  }

  const handleRefreshAlert = () => onUpdateAlert()

  const hasAlerts = Boolean(currentAlerts.length)

  return hasAlerts ? (
    <div className={`${BASE_CLASS}-items`}>
      {currentAlerts.map((userAlert, index) => (
        <div key={userAlert.alertId} className={`${BASE_CLASS}-card`}>
          <AtomCard
            content={() => (
              <CardAlert
                allowFiltersUpdate={!isMotos}
                itemPosition={index}
                listFiltersOptions={listFiltersOptions}
                onRefreshAlert={handleRefreshAlert}
                pageName={pageName}
                setNotificationType={setNotificationType}
                setShow={setShow}
                userAlert={userAlert}
              />
            )}
            key={userAlert.alertId}
            responsive
          />
        </div>
      ))}
      <NotificationAlert onCloseNotification={closeNotification} isOpen={show} showNotification={notificationType} />
    </div>
  ) : (
    <EmptyCaseAlerts />
  )
}

WrapperAlerts.displayName = 'WrapperAlerts'
WrapperAlerts.propTypes = {
  currentAlerts: PropTypes.array,
  listFiltersOptions: PropTypes.object,
  onUpdateAlert: PropTypes.func,
  pageName: PropTypes.string
}

export default WrapperAlerts
